import TagManager from 'react-gtm-module';
import isEmpty from 'lodash/isEmpty';
import extractFields from 'lib/trackers/GoogleAnalytics/extractFields';
import { get } from 'lodash';

const extractNodeFromEdges = (data, listName = '') => {
  const {
    edges,
    totalCount,
  } = data;
  if (totalCount) {
    return edges.map(({ node }) => {
      return {
        listName,
        ...node,
      };
    });
  }
  return [];
};

const translateItems = (list) => {
  return list.map((l, index) => ({
    item_name: get(l, 'name'),
    item_id: get(l, 'id'),
    value: '1.00',
    item_brand: l.community ? get(l.community, 'name') : '',
    item_category: (get(l, 'categories') || []).map((c) => c.name).join(', '),
    item_category2: get(l, 'chatterbox') ? 'Chatterbox' : 'House Party',
    item_list_name: l.listName,
    index: index + 1,
  }));
};

const extractItems = ({ event, viewer,
}) => {
    const {
      applicable,
      partying,
      comingsoon,
    } = viewer;
    const discover = [];
    if (event) {
      discover.push(event);
    } else if (applicable?.edges || partying?.edges || comingsoon?.edges) {
      discover.push(...[
        ...extractNodeFromEdges(applicable, 'Applications Now Open'),
        ...extractNodeFromEdges(comingsoon, 'Coming Soon'),
        ...extractNodeFromEdges(partying, 'Now Experiencing'),
      ]);
    }

  return { items: translateItems(discover) };
};

export default class GTM {
  constructor(container) {
    this.container = container;
    this.init();
  }
  setFields = data => {
    const fields = {};
    if (!isEmpty(data)) {
      const {
        communityId,
        communityName,
        eventId,
        eventName,
        productId,
        productName,
        userId,
        categories,
      } = extractFields(data);
      if (eventId) {
        fields.eventId = eventId;
      }
      if (eventName) {
        fields.eventName = eventName;
      }
      if (communityId) {
        fields.communityId = communityId;
      }
      if (communityName) {
        fields.productName = communityName;
      }
      if (productId) {
        fields.productId = productId;
      }
      if (productName) {
        fields.productName = productName;
      }
      if (categories && categories.length) {
        fields.categories = categories;
      }
      if (userId) {
        fields.userId = userId;
      }
    }
    return fields;
  }

  init(args = {}) {
    try {
      TagManager.initialize({
        gtmId: this.container,
        ...args,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(`Google tag manager initialization failed, ${e.message || e}`);
    }
  }

  dataLayer(args, data, isEcommerce) {
    try {
      let ecommerce = {};
      if (isEcommerce) {
        ecommerce = extractItems(data);
      }
      const fields = data.event ? this.setFields(data) : {};
      if (isEcommerce) {
        TagManager.dataLayer({ dataLayer: {
          ...args,
          ...fields,
          ecommerce,
        },
      });
      } else {
        TagManager.dataLayer({ dataLayer: {
            ...args,
            ...fields,
          },
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(`Google tag manager data layer init failed, ${e.message || e}`);
    }
  }
}
